import '@/lib/i18n';

import { QueryProvider } from './QueryProvider';
import { AuthProvider } from '@/context/authContext';
import { ToastProvider } from '@/providers/ToastProvider';

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <QueryProvider>
      <ToastProvider>
        <AuthProvider>{ children }</AuthProvider>
      </ToastProvider>
    </QueryProvider>
  );
}
